<template>
  <div class="tab">
    <main class="page_container">
      <TableLogs :data="data" :loading="loading" :link-keys="linkKeys" :keys="keys" @fetch="onFetchData" />
    </main>
  </div>
</template>
<script>
import TableLogs from "@/core/components/TableLogs/index";
import logsMixin from "@/core/components/TableLogs/logsMixin";
import { ApiService } from "@/api";

export default {
  name: "ServersLogs",
  components: {
    TableLogs,
  },
  mixins: [logsMixin],
  data() {
    return {
      keys: ["login", "client_name", "id_account"],
      linkKeys: {
        id_account: `${process.env.BASE_URL}#/client/edit/`,
      },
    };
  },
  methods: {
    fetchLogs: ApiService.logs.getClientsLogs,
  },
};
</script>
